import React from 'react';

const InstructorLanguagesPopup = ({ setShowInstructorLanguagesPopup, languages }) => {
  const handleCancelPopupClick = () => {
    setShowInstructorLanguagesPopup(false);
  };

  return (
    <div className="fixed inset-0 z-[99] flex items-center justify-center"
        style={{
            backgroundColor: "rgba(0, 0, 0, 0.05)", // ⬅️ very light black background
            backdropFilter: "blur(2px)",           // ⬅️ optional blur
            WebkitBackdropFilter: "blur(2px)",     // ⬅️ Safari support
        }}
    >
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg w-[340px] lg:w-[370px]">      
            <div className="absolute top-2 right-2 z-10">
                <img
                className="cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt="Close"
                onClick={handleCancelPopupClick}
                />
            </div>

            <div className="flex flex-col gap-[10px] mt-[15px]">
                <p className="text-[16px] text-center font-bold">Instructor Languages</p>
                <p className="text-[16px] text-center">
                    {languages.join(', ')}
                </p>

            </div>
        </div>
    </div>
  );
};

export default InstructorLanguagesPopup;
